// extracted by mini-css-extract-plugin
module.exports = {"container":"InviteToStage_container__2xkEH","content":"InviteToStage_content__1HJFw","animated":"InviteToStage_animated__2FCBk"};